import { render, staticRenderFns } from "./issue_warning.vue?vue&type=template&id=1120fac8&"
import script from "./issue_warning.vue?vue&type=script&lang=js&"
export * from "./issue_warning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "issue_warning.vue"
export default component.exports